import { formatUsdcRaw } from "../../lib/format";

export type Mode = "regular" | "deposit" | "withdrawal";

interface ControlsProps {
	cashUsdc: string;
	mode: Mode;
	cashBufferWeight: string;
	requiredCashWeight: string;
	resolvedCashRaw?: string;
	onCashUsdcChange: (v: string) => void;
	onModeChange: (m: Mode) => void;
	onCashBufferWeightChange: (v: string) => void;
	onRequiredCashWeightChange: (v: string) => void;
}

/**
 * Inline controls in the Rebalance section header. Lets the operator
 * pick the optimizer mode + override the cash & per-mode weights, or
 * leave them blank to use the on-chain / default values.
 */
export function RebalanceControls(props: ControlsProps) {
	const {
		cashUsdc,
		mode,
		cashBufferWeight,
		requiredCashWeight,
		resolvedCashRaw,
		onCashUsdcChange,
		onModeChange,
		onCashBufferWeightChange,
		onRequiredCashWeightChange,
	} = props;

	return (
		<div className="flex flex-wrap items-center gap-2 text-xs">
			<label className="flex items-center gap-1.5">
				<span className="text-slate-400">Cash</span>
				<input
					className="w-32 rounded-md border border-slate-800 bg-slate-950 px-2 py-1 text-sm"
					// Empty input = backend defaults to on-chain USDC balance.
					// Show that resolved value as the placeholder so users see
					// what the optimizer is actually using without having to
					// re-type it.
					placeholder={
						resolvedCashRaw ? `auto: ${formatUsdcRaw(resolvedCashRaw)}` : "auto"
					}
					inputMode="decimal"
					value={cashUsdc}
					onChange={(e) => onCashUsdcChange(e.target.value)}
					title="Cash USDC the optimizer can allocate. Leave empty to use the wallet's on-chain balance."
				/>
			</label>
			<select
				className="rounded-md border border-slate-800 bg-slate-950 px-2 py-1"
				value={mode}
				onChange={(e) => onModeChange(e.target.value as Mode)}
			>
				<option value="regular">Regular</option>
				<option value="deposit">Deposit</option>
				<option value="withdrawal">Withdrawal</option>
			</select>
			{mode === "deposit" && (
				<input
					className="w-20 rounded-md border border-slate-800 bg-slate-950 px-2 py-1 text-sm"
					placeholder="0.01"
					value={cashBufferWeight}
					onChange={(e) => onCashBufferWeightChange(e.target.value)}
					title="cashBufferWeight"
				/>
			)}
			{mode === "withdrawal" && (
				<input
					className="w-20 rounded-md border border-slate-800 bg-slate-950 px-2 py-1 text-sm"
					placeholder="0.10"
					value={requiredCashWeight}
					onChange={(e) => onRequiredCashWeightChange(e.target.value)}
					title="requiredCashWeight"
				/>
			)}
		</div>
	);
}
